import styled from 'styled-components';
import { Text13Bold } from '../utils/Text/Text.styles';

export const StepperWrapper = styled.div`
  width: 2.4rem;
  height: 2.4rem;
  position: relative;
`;

export const CircleSVG = styled.svg`
  position: absolute;
  width: 2.4rem;
  height: 2.4rem;
  transform: rotate(-90deg);
`;

export const CircleBackground = styled.circle`
  fill: none;
  stroke-width: 3;
  stroke: #d8eaf9;
`;

export const CircleProgress = styled.circle`
  fill: none;
  stroke: #1672ba;
  stroke-width: 3;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.3s ease;
`;

export const StepNumber = styled(Text13Bold)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
